import { atom } from 'jotai';

export interface ChatNotificationItem {
    id: string;            // 내부 ID — 동일 메시지 중복 방지
    messageId?: string;
    roomId: string;
    roomName?: string;
    senderNickname: string;
    senderProfileUrl?: string;
    content: string;
    messageType: 'TEXT' | 'IMAGE' | 'SYSTEM' | 'LOCATION';
    createdAt: string;
    /** 현재 표시 중인지 (자동 dismiss 타이머가 살아있는 동안 true) */
    visible: boolean;
}

/** 화면에 표시 중인 배너 스택 (최신 메시지가 앞쪽). 최대 3개 유지 — 그 외는 자동 폐기. */
export const chatBannerStackAtom = atom<ChatNotificationItem[]>([]);

export const MAX_VISIBLE_BANNERS = 3;
